import { render } from "./timetable.vue?vue&type=template&id=5846e8aa&scoped=true"
import script from "./timetable.vue?vue&type=script&lang=js"
export * from "./timetable.vue?vue&type=script&lang=js"

import "./timetable.vue?vue&type=style&index=0&id=5846e8aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5846e8aa"

export default script